/**
 * @generated SignedSource<<2a6ba681f4e8f634a7fb536192e6eadd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OfflineLicenseTokenRequestStatus = "NONE" | "REQUESTED" | "%future added value";
export type OfflineLicenseTokenCreationModalCreateLicenseMutation$variables = {
  appId: string;
  expiry: string;
};
export type OfflineLicenseTokenCreationModalCreateLicenseMutation$data = {
  readonly createOfflineLicense: {
    readonly app: {
      readonly id: string;
      readonly licenses: ReadonlyArray<{
        readonly createdAt: string;
        readonly expiresAt: string | null | undefined;
        readonly id: string;
        readonly token: string;
      }>;
      readonly offlineLicenseRequestStatus: OfflineLicenseTokenRequestStatus;
    };
    readonly createdAt: string;
    readonly expiresAt: string | null | undefined;
    readonly id: string;
  };
};
export type OfflineLicenseTokenCreationModalCreateLicenseMutation = {
  response: OfflineLicenseTokenCreationModalCreateLicenseMutation$data;
  variables: OfflineLicenseTokenCreationModalCreateLicenseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "expiry"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appId",
        "variableName": "appId"
      },
      {
        "kind": "Variable",
        "name": "expiry",
        "variableName": "expiry"
      }
    ],
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "createOfflineLicense",
    "plural": false,
    "selections": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "app",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offlineLicenseRequestStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "licenses",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "token",
                "storageKey": null
              },
              (v2/*:: as any*/),
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OfflineLicenseTokenCreationModalCreateLicenseMutation",
    "selections": (v4/*:: as any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "OfflineLicenseTokenCreationModalCreateLicenseMutation",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "e50cde10be1cdf67ad595ead9200fc8e",
    "id": null,
    "metadata": {},
    "name": "OfflineLicenseTokenCreationModalCreateLicenseMutation",
    "operationKind": "mutation",
    "text": "mutation OfflineLicenseTokenCreationModalCreateLicenseMutation(\n  $appId: ID!\n  $expiry: String!\n) {\n  createOfflineLicense(appId: $appId, expiry: $expiry) {\n    id\n    expiresAt\n    createdAt\n    app {\n      id\n      offlineLicenseRequestStatus\n      licenses {\n        id\n        token\n        expiresAt\n        createdAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa57e4e76f05287307c636223144ad32";

export default node;
